import { OnboardingStateModel, OnboardingSteps } from './onboarding.model';
import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import {
  ClearRegisterBusinessDetails,
  ClearRegisterDetails,
  GoToStep,
  UpdatedSideGraphic,
  UpdateRegisterBizDetails,
  UpdateRegisterDetails,
  UpdateRegisterStepAndSideGraphic,
} from './onboarding.actions';

@State<OnboardingStateModel>({
  name: 'onboarding',
  defaults: {
    step: OnboardingSteps.GET_STARTED,
    graphic: 'svg_default.svg',
    showProgress: false,
  },
})
@Injectable()
export class OnboardingState {
  @Action(GoToStep)
  setStep(ctx: StateContext<OnboardingStateModel>, action: GoToStep) {
    let graphic;
    let showProgress = true;
    switch (action.step) {
      case OnboardingSteps.LOGIN:
        graphic = 'login.svg';
        showProgress = false;
        break;
      case OnboardingSteps.GET_STARTED:
        graphic = 'reg1.svg';
        break;
      case OnboardingSteps.BUSINESS_DETAILS:
        graphic = 'reg2.svg';
        break;
      case OnboardingSteps.VERIFY_EMAIL:
        graphic = 'reg3.svg';
        break;
      case OnboardingSteps.PASSWORD:
        graphic = 'reg5.svg';
        break;
      case OnboardingSteps.VERIFY_PHONE:
        graphic = 'reg4.svg';
        break;
      case OnboardingSteps.SUBSCRIPTION_SELECTION:
        graphic = 'reg9.svg';
        break;
      case OnboardingSteps.BUSINESS_CERTIFICATE:
        graphic = 'reg6.svg';
        break;
      case OnboardingSteps.FINAL:
        graphic = 'reg7.svg';
        break;
      case OnboardingSteps.PASSWORD_REQUEST:
        graphic = 'password.svg';
        break;
      case OnboardingSteps.EMAIL_CHECK:
        graphic = 'reg3.svg';
        break;
      case OnboardingSteps.DIRECTOR_APPROVAL:
        graphic = 'reg5.svg';
        break;
      case OnboardingSteps.SUCCESS:
        graphic = 'reg8_success.svg';
        break;
      default:
        graphic = 'svg_default.svg';
        break;
    }
    ctx.patchState({ step: action.step, graphic: graphic, showProgress: showProgress });
  }

  @Action(UpdateRegisterStepAndSideGraphic)
  setStepAndGraphic(ctx: StateContext<OnboardingStateModel>, action: UpdateRegisterStepAndSideGraphic) {
    ctx.patchState({ step: action.step, graphic: action.graphic });
  }

  @Action(UpdatedSideGraphic)
  setGraphic(ctx: StateContext<OnboardingStateModel>, action: UpdatedSideGraphic) {
    ctx.patchState({ graphic: action.graphic });
  }

  @Action(UpdateRegisterDetails)
  updateRegisterDetails(ctx: StateContext<OnboardingStateModel>, action: UpdateRegisterDetails) {
    ctx.patchState({ registerDetails: action.details });
  }

  @Action(ClearRegisterDetails)
  clearRegisterDetails(ctx: StateContext<OnboardingStateModel>) {
    ctx.patchState({ registerDetails: undefined });
  }

  @Action(UpdateRegisterBizDetails)
  updateRegisterBizDetails(ctx: StateContext<OnboardingStateModel>, action: UpdateRegisterBizDetails) {
    ctx.patchState({ businessDetails: action.details });
  }

  @Action(ClearRegisterBusinessDetails)
  clearRegisterBusinessDetails(ctx: StateContext<OnboardingStateModel>) {
    ctx.patchState({ businessDetails: undefined });
  }
}
